/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateEmailReadByDataSchema = z.object({
	userId: z.string(),
	readAt: z.iso.datetime().nullable(),
})

export type CandidateEmailReadByDataSchema = z.infer<typeof candidateEmailReadByDataSchema>
